document.addEventListener("DOMContentLoaded", function () {

    const calculator = document.querySelector('.twz-element-calculator')
    
    if (calculator) {
        const slider = document.getElementById('slider');
        const sliderLabel = document.getElementById('sliderLabel');
        const totalPrice = document.getElementById('totalPrice');
        const gemPriceBox = document.getElementById('gem-price-box');

        const priceRanges = [
            { max: 10, price: 1.25, step: 9 },
            { max: 50, price: 1.25, step: 10 },
            { max: 500, price: 0.99, step: 50 },
            { max: 2000, price: 0.82, step: 100 },
            { max: 5000, price: 0.70, step: 250 },
            { max: 10000, price: 0.63, step: 500 },
            { max: 75000, price: 0.59, step: 1000 }
        ];

        let isSliderMoving = false;

        function calculateTotalCost(value) {
            let remaining = value;
            let cost = 0;
            let previousMax = 0;

            for (let i = 0; i < priceRanges.length; i++) {
                let { max, price } = priceRanges[i];
                if (remaining > 0) {
                    let count = Math.min(remaining, max - previousMax);
                    cost += count * price;
                    remaining -= count;
                    previousMax = max;
                } else {
                    break;
                }
            }

            return cost;
        }

        function formatPrice(value) {
            return '€ ' + value.toLocaleString('nl-NL', { 
                minimumFractionDigits: value % 1 === 0 ? 0 : 2, 
                maximumFractionDigits: 2 
            });
        }

        function updateStep(value) {
            let step = 1;

            for (let i = 0; i < priceRanges.length; i++) {
                if (value <= priceRanges[i].max) {
                    step = priceRanges[i].step;
                    break;
                }
            }

            if (value + step > 75000) {
                step = 75000 - value;
            }

            slider.step = step;
            return step;
        }

        function adjustValueToStep(value, step) {
            return isSliderMoving ? Math.max(1, value - 1) : value; 
        }

        function updateValues(value) {
            if (value > 75000) {
                value = 75000;
            }

            const step = updateStep(value);
            const correctedValue = adjustValueToStep(value, step);

            slider.value = correctedValue;
            sliderLabel.value = correctedValue;

            const aantalAansluitingen = document.querySelector('input[name="aantal_aansluitingen"]');
            if (aantalAansluitingen) {
                aantalAansluitingen.value = correctedValue;
            }

            const totalCost = calculateTotalCost(correctedValue);
            totalPrice.textContent = formatPrice(totalCost);

            const averagePrice = correctedValue > 0 ? totalCost / correctedValue : 0;
            gemPriceBox.textContent = formatPrice(averagePrice);
        }

        slider.addEventListener('input', function () {
            isSliderMoving = true;
            let value = parseInt(this.value);
            if (value > 75000) value = 75000;
            updateValues(value);
        });

        sliderLabel.addEventListener('input', function () {
            let value = this.value.replace(/\D/g, '');
            if (value === '') return;

            value = parseInt(value);
            if (value > 75000) value = 75000;
            isSliderMoving = false;
            updateValues(value);
        });

        document.addEventListener('input', function (event) {
            if (event.target && event.target.name === "aantal_aansluitingen") {
                let value = event.target.value.replace(/\D/g, '');
                if (value === '') return;

                value = parseInt(value);
                if (value > 75000) value = 75000;
                isSliderMoving = false;
                updateValues(value);
            }
        });

        window.onload = function () {
            updateValues(500);
        };
    }
});